import { useDateFormat } from "@vueuse/core";

/**
 * Generates the status and button text for a given number based on its status, tariff end date, and integrations.
 *
 * @param {Object} number - The number object containing information about the number.
 * @param {string} number.status - The current status of the number.
 * @param {Date} number.tariff_end_date - The end date of the tariff.
 * @param {boolean} number.prepayment_enabled - Indicates if prepayment is enabled for the number.
 * @param {Array} number.integrations - The integrations associated with the number.
 * @param {boolean} number.visibility - Indicates if the number is visible or not.
 *
 * @return {Object} An object containing the status and button text.
 * @return {string} return.status - One of the following status values:
 *   - "active_pre" (Активирован в аванс)
 *   - "active" (Активен)
 *   - "waiting_for" (Не подключен к СРМ)
 *   - "number_disable" (Номер отключен)
 *   - "requires_activation" (Требует активации)
 *   - "error" (Ошибка)
 * @return {string} return.buttonText - The button text associated with the current status.
 *   - "pay_button" (Оплатить)
 *   - "activation_button" (Активировать)
 *   - "help_button" (Помощь)
 *   - "return" (Вернуть номер)
 */
export default function statusNumberConfig(number) {
    let status, buttonText;

    // maybe will need
    const now = new Date();
    const endTariff = new Date(number.tariff_end_date);
    const isActiveTariff =
        useDateFormat(endTariff, "YYYYMMDD").value -
        useDateFormat(now, "YYYYMMDD").value >=
        0;

    // const isActiveTariff = !!number.tariff_end_date;
    const hasIntegration = number.integrations?.length > 0;

    if (number.status === "Activated") {
        if (isActiveTariff) {
            if (hasIntegration) {
                status = number.prepayment_enabled
                    ? "active_pre" // 'Активирован в аванс'
                    : "active"; // 'Активен'
            } else {
                status = "waiting_for"; // 'Не подключен к СРМ'
            }
        } else if (!isActiveTariff) {
            status = "number_disable";
        } else {
            status = "error";
        }

        buttonText = status === "error" ? "help_button" : "pay_button"; // 'Оплатить'
    } else if (isActiveTariff || !number.tariff_end_date) {
        status = "requires_activation"; // 'Требует активации'
        buttonText = "activation_button"; // 'Активировать'
    } else if (!isActiveTariff) {
        status = "number_disable";
        buttonText = "pay_button";
    } else {
        status = "error";
        buttonText = "error";
    }
    if (!number.visibility) {
        buttonText = "return"; // 'Вернуть номер'
    }
    return {
        status,
        buttonText,
    };
}
